// Version du frontend construit, figée par Vite au build (voir build-version.ts).
// Les gardes `typeof` évitent une ReferenceError si un outil charge ce module
// sans la configuration Vite ; l'étiquette est alors vide plutôt qu'inventée.

export const BUILD_VERSION: string =
  typeof __STREAMING_VERSION__ === "string" ? __STREAMING_VERSION__ : "";
export const BUILD_COMMIT: string =
  typeof __STREAMING_COMMIT__ === "string" ? __STREAMING_COMMIT__ : "unknown";
export const BUILD_DIRTY: boolean | null =
  typeof __STREAMING_DIRTY__ === "boolean" ? __STREAMING_DIRTY__ : null;

/** « v1.9.0 », suffixé de « * » si la source construite n'était pas commitée. */
export function versionLabel(): string {
  if (!BUILD_VERSION) return "";
  return `v${BUILD_VERSION}${BUILD_DIRTY === true ? "*" : ""}`;
}

/** Infobulle : commit court et état, sans chemin ni secret. */
export function versionTitle(): string {
  const commit = BUILD_COMMIT === "unknown" ? "commit inconnu" : `commit ${BUILD_COMMIT.slice(0, 12)}`;
  const state =
    BUILD_DIRTY === true ? "modifications non commitées" : BUILD_DIRTY === false ? "source commitée" : "état inconnu";
  return `Version construite ${versionLabel()} — ${commit}, ${state}`;
}
